import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const getDocumentTemplateOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.ContractDocumentTemplateOptionRawType>
  >(API.GET.documentTemplateOptions, {
    headers: { Accept: 'application/vnd.falcon.v2+json' },
  });

  return data.data.map(({ attributes }) => ({
    value: attributes.code,
    label: attributes.title,
  }));
};

export const useGetDocumentTemplateOptions = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.CONTRACT_DOCUMENT_TEMPLATE_OPTIONS],
    queryFn: getDocumentTemplateOptions,
    staleTime: 1000 * 60 * 10,
  });
};
